import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form } from 'antd';

const VideoOrderProvider = (props) => {
  const api = new API();
  const [videoOrderCatList, setVideoOrderCatList] = useState([]);
  const [videoOrderSubCatList, setVideoOrderSubCatList] = useState([]);
  const [videoOrderCatListLoader, setVideoOrderCatListLoader] = useState(false);
  const [videoOrderSubCatListLoader, setOrderSubCatListLoader] = useState(false);
  const [videoOrderTableFilter, setVideoOrderTableFilter] = useState({
    page: 1,
    limit: 100,
  })
  const [subCatOrderId, setSubCatOrderId] = useState("");
  const [videoOrderList, setVideoOrderList] = useState([]);
  const [videoOrderListLoader, setVideoOrderListLoader] = useState(false);
  const fetchVideoOrderCatList = async () => {
    setVideoOrderCatListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("videoorder/categorylist", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoOrderCatList(res?.data?.data);
        } else {
          setVideoOrderCatList([]);
        }
        setVideoOrderCatListLoader(false);
      }));
  }
  const fetchVideoOrderSubCatList = async (cid) => {
    setOrderSubCatListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("videoorder/subcategorylist", {
        category_id: cid
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoOrderSubCatList(res?.data?.data);
        } else {
          setVideoOrderSubCatList([]);
        }
        setOrderSubCatListLoader(false);
      }));
  }
  const fetchVideoOrderList = async (data) => {
    setVideoOrderListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setSubCatOrderId(data?.subcategory_id);
      (await api.getAll("videoorder/videotablelist_v2", {
        category_id: data?.category_id,
        subcategory_id: data?.subcategory_id,
        ...videoOrderTableFilter
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoOrderList(res?.data?.data);
        } else {
          Widget.showMessage('error',err?.response?.data?.message);
          setVideoOrderList([]);
        }
        setVideoOrderListLoader(false);
      }));
  }

  const fetOrderSub = async (data) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pearlsorder/suborder_v2", {
        ids: data,
        subcategory_id: subCatOrderId,
        type: "videos"
      }, (err, res) => {
        if(err){
          Widget.showMessage('error',err?.response?.data?.message);
        }
      }));
  }
  const fetOrderTopic = async (data) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pearlsorder/suborder_v2", {
        ids: data,
        subcategory_id: subCatOrderId,
        type: "videos"
      }, (err, res) => {
        if(err){
          Widget.showMessage('error',err?.response?.data?.message);
        }
      }));
  }

  const videoRowUpdateOrder = async (data) => {
    localStorage.getItem("rxdx_admin_login") &&
      await api.create("pearlsorder/suborder_v2", {ids:data,subcategory_id: subCatOrderId,
        type: "videos"}, (err, res) => {
        if (res?.data?.status === 200) {} else {
          Widget.showMessage('error',err?.response?.data?.message);
        }
      });
  };

   return (
    <Context.Provider value={{
      ...props,
      videoOrderCatList, setVideoOrderCatList,
      videoOrderSubCatList, setVideoOrderSubCatList,
      videoOrderCatListLoader, setVideoOrderCatListLoader,
      videoOrderSubCatListLoader, setOrderSubCatListLoader,
      videoOrderTableFilter, setVideoOrderTableFilter,
      videoOrderList, setVideoOrderList,
      videoOrderListLoader, setVideoOrderListLoader,
      fetchVideoOrderCatList,
      fetchVideoOrderSubCatList,
      fetchVideoOrderList,
      fetOrderSub,
      fetOrderTopic,
      videoRowUpdateOrder
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default VideoOrderProvider;